import { IVideo } from 'lib_ts/interfaces/i-video';
import { cloneDeep } from 'lodash';
import { create } from 'zustand';

interface ModelState {
  // for tracking interim changes in the forms without modifying the original values (until save)
  model: IVideo | undefined;
}

interface ModelActions {
  initModel: (value: IVideo) => void;
  mergeModel: (value: Partial<IVideo>) => void;
}

type ModelStore = ModelState & ModelActions;

const useVideoLibrarySidebarStore = create<ModelStore>((set, get) => ({
  model: undefined,

  // whenever changing video selection
  initModel: (value) => set({ model: cloneDeep(value) }),

  // whenever editing the video from different tabs
  mergeModel: (value) => {
    const { model } = get();

    if (!model) {
      console.error('Init a model first');
      return;
    }

    const nextModel = { ...model, ...value };

    set({ model: nextModel });
  },
}));

export default useVideoLibrarySidebarStore;
